import Parse from 'html-react-parser';

function BMP20267(props) {
    let svgCode =
    `<svg width="20" height="44" viewBox="0 0 20 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 8H2V20H18V8ZM12 12H8V16H12V12Z" fill="grey"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2L14 2L14 4L8 4L8.00001 6L6 6.00001L6.00001 8L4.00001 8.00001L3.99999 4.00001L6 4.00001L6 2Z" fill="grey"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 30H2V42H18V30ZM12 34H8V38H12V34Z" fill="grey" fill-opacity="0.2"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.65094 23.9672L14 24.0044V25.9858L16 25.9575V29.9717L14 29.9717V27.986L12 28.0142V25.9956L7.65095 25.9762L7.65095 27.9717L5.65094 27.9717L5.65095 29.9717L3.65095 29.9717L3.65094 25.9717L5.65095 25.9717L5.65094 23.9672Z" fill="grey" fill-opacity="0.2"/>
    </svg>`

    props.svgReturn(65, svgCode, "bmp00267", 20, 44);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20267;